import { Briefcase, Palette, ScrollText, Sparkles, Sliders, Link2, Upload } from "lucide-react";

/**
 * Step metadata for the client business brief.
 * Adding/removing a step? update STEPS in ClientBriefWizard.jsx too.
 */
export const FONT_OPTIONS = [
  { key: "heebo", label: "Heebo (קלאסי, נקי)", css: "'Heebo', system-ui, sans-serif" },
  { key: "rubik", label: "Rubik (עגול, ידידותי)", css: "'Rubik', system-ui, sans-serif" },
  { key: "assistant", label: "Assistant (מודרני)", css: "'Assistant', system-ui, sans-serif" },
  { key: "frank-ruhl", label: "Frank Ruhl (יוקרתי, סריפי)", css: "'Frank Ruhl Libre', serif" },
  { key: "varela", label: "Varela Round (חם)", css: "'Varela Round', system-ui, sans-serif" },
];

export const BUTTON_STYLES = [
  { key: "rounded", label: "מעוגל", radius: "rounded-full" },
  { key: "soft", label: "רך", radius: "rounded-xl" },
  { key: "sharp", label: "חד", radius: "rounded-sm" },
  { key: "outline", label: "מתאר", radius: "rounded-xl outline" },
];

export const FEATURES = [
  { key: "mobile_app", label: "אפליקציה לטלפון יעודית", emoji: "📱" },
  { key: "whatsapp_bot", label: "בוט AI לוואטסאפ", emoji: "🤖" },
  { key: "invoice_automation", label: "אוטומציית חשבוניות מהירה ללקוח", emoji: "🧾" },
  { key: "campaigns_whatsapp", label: "דיוור הודעות בוואטסאפ", emoji: "💬" },
  { key: "campaigns_sms", label: "דיוור הודעות SMS", emoji: "📨" },
  { key: "campaigns_email", label: "דיוור הודעות אימייל", emoji: "✉️" },
];

export const SOCIALS = [
  { key: "facebook_url", label: "Facebook", placeholder: "https://facebook.com/your-page" },
  { key: "instagram_url", label: "Instagram", placeholder: "https://instagram.com/your-handle" },
  { key: "tiktok_url", label: "TikTok", placeholder: "https://tiktok.com/@your-handle" },
];

export { Briefcase, Palette, ScrollText, Sparkles, Sliders, Link2, Upload };
